import { Component, OnInit } from '@angular/core';
import { NgbActiveModal,NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import {AuthServiceService} from '../../../shareModule/services/auth-service.service';
import {LocalServiceService} from '../../../shareModule/services/local-service.service';
import {Router} from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-sign-in-modal',
  templateUrl: './sign-in-modal.component.html',
  styleUrls: ['./sign-in-modal.component.scss']
})
export class SignInModalComponent implements OnInit {

  userSignIn: FormGroup;
  submitted=false;
  error="";
  yourIp:any;

  constructor(public activeModal: NgbActiveModal,
              private modalService: NgbModal,
              private toastr: ToastrService,
              private http:HttpClient,
              private auth:AuthServiceService,
              private local:LocalServiceService,
              private router:Router,
              private formBuilder: FormBuilder,) { }

  ngOnInit(): void {

    this.userSignIn = this.formBuilder.group({
      usersEmail: ['', [Validators.required, Validators.email]],
      usersPassword: ['', [Validators.required, Validators.minLength(5)]],
    });
    this.getIPAddress();
  }

  get userIn()  { return this.userSignIn.controls;}

  usersignin(){
    this.submitted = true;
    if(this.userSignIn.invalid){
      return;
    }

    let myIp = this.local.getMyIp();

    if(!myIp){
      myIp = this.yourIp;
    }

    let data = {'email':this.userIn.usersEmail.value,'password':this.userIn.usersPassword.value, 'type': 0};

    this.auth.login(data).subscribe((response:any)=>{
      console.log(response.body,'--------------------------login API response')

        this.toastr.success('Logged in Successfully');
        this.modalService.dismissAll();
        this.local.saveLoginUserData(response.body);

        
        this.router.navigate(['/admin/home']);
      let data = {'ipAddress':myIp.ip};

      this.auth.save_ip_address(data).subscribe((response:any)=>{
        // console.log('====================successip',response.body);
      },(e)=>{
        // console.log('====================errorip',e.error.message);
      })

    },(e)=>{
      if(e.status == 400){
        this.toastr.error(e.error.message)
        this.modalService.dismissAll()
      }
    })

  }

  // showSignUpModal(){
  //   this.modalService.dismissAll();
  //   this.modalService.open(SignUpModalComponent, { size: 'lg', ariaLabelledBy: 'modal-basic-title'});
  // }
  dismiss(){ this.modalService.dismissAll();}

  getIPAddress()
  {
    this.http.get("https://api.ipify.org?format=json").subscribe((res:any)=>{
      this.yourIp = res.ip;
    });
    // this.http.get("https://jsonip.com/").subscribe((res:any)=>{
    //   this.yourIp = res.ip;
    // });
  }

}




